const buttonTableActions = {
  text: 'filtros'
};

export default buttonTableActions;
